import { render, staticRenderFns } from "./Compression_Capabilities.vue?vue&type=template&id=45593b87&scoped=true"
import script from "./Compression_Capabilities.vue?vue&type=script&lang=js"
export * from "./Compression_Capabilities.vue?vue&type=script&lang=js"
import style0 from "./Compression_Capabilities.vue?vue&type=style&index=0&id=45593b87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45593b87",
  null
  
)

export default component.exports